import React from "react"
import PropTypes from "prop-types"
import {
  PostCard,
  ContentContainer,
  BlogContent,
  Tag,
  Category,
  Seo,
} from "../components"
import { graphql } from "gatsby"

const Tags = ({ pageContext, data }) => {
  const { tag } = pageContext
  const { totalCount } = data.postsRemark
  const allPosts = data.postsRemark.edges
  const posts = allPosts
  const allTags = data.tagsGroup.group
  const allCategories = data.categoriesGroup.group
  const defaultImage = data.defaultImage.fluid

  const tagHeader = `TAG: "${tag}" (${totalCount})`

  return (
    <ContentContainer>
      <Seo
        title="Blog Posts"
        // image={seoImage}
        description="Page for guides, tutorial, or just notes."
      />
      <BlogContent>
        <div className="container">
          <section className="blog-content">
            <div className="col-md-12 tag-title-container">
              <h1>{tagHeader}</h1>
            </div>
            {posts.map(({ node }, index) => (
              <PostCard
                key={index}
                to={node.frontmatter.slug}
                description={node.frontmatter.description}
                title={node.frontmatter.title}
                date={node.frontmatter.date}
                fluidImage={
                  node.frontmatter.image
                    ? node.frontmatter.image.childImageSharp.fluid
                    : defaultImage
                }
              />
            ))}
          </section>

          <section className="blog-sidebar">
            {/* <Tags /> */}
            <div className="side-container">
              <h1>All Tags</h1>
              {allTags.map(node => (
                <Tag href={`/tags/${node.fieldValue}/`}>{node.fieldValue}</Tag>
              ))}
            </div>

            <div className="side-container">
              <h1>All Categories</h1>
              {allCategories.map(node => (
                <Category
                  href={`/categories/${node.fieldValue}/`}
                  count={node.totalCount}
                >
                  {node.fieldValue}
                </Category>
              ))}
            </div>
          </section>
        </div>
      </BlogContent>
    </ContentContainer>
  )
}

Tags.propTypes = {
  pageContext: PropTypes.shape({
    tag: PropTypes.string.isRequired,
  }),

  data: PropTypes.shape({
    allMarkdownRemark: PropTypes.shape({
      totalCount: PropTypes.number.isRequired,
      edges: PropTypes.arrayOf(
        PropTypes.shape({
          node: PropTypes.shape({
            frontmatter: PropTypes.shape({
              title: PropTypes.string.isRequired,
            }),
            fields: PropTypes.shape({
              slug: PropTypes.string.isRequired,
            }),
          }),
        }).isRequired
      ),
    }),
  }),
}
export default Tags

export const pageQuery = graphql`
  query($tag: String) {
    postsRemark: allMdx(
      sort: { order: DESC, fields: [frontmatter___date] }
      limit: 2000
      filter: { frontmatter: { tags: { in: [$tag] } } }
    ) {
      totalCount
      edges {
        node {
          id
          frontmatter {
            slug
            title
            description
            image {
              childImageSharp {
                fluid {
                  ...GatsbyImageSharpFluid
                }
              }
            }
            date(formatString: "MMMM YYYY")
            tags
          }
        }
      }
    }
    defaultImage: file(relativePath: { eq: "coding_default.jpg" }) {
      childImageSharp {
        # Specify a fluid image and fragment
        # The default maxWidth is 800 pixels
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    tagsGroup: allMdx(limit: 2000) {
      group(field: frontmatter___tags) {
        fieldValue
      }
    }

    categoriesGroup: allMdx(limit: 2000) {
      group(field: frontmatter___category) {
        fieldValue
        totalCount
      }
    }
  }
`
